import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-d867568e")

_pushScopeId("data-v-d867568e")
const _hoisted_1 = { class: "results-table" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Total Income:")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Less deductions:")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("BIK deduction:")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Work expenses:")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Pension contributions:")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Income taxed at standard rate:")
const _hoisted_8 = /*#__PURE__*/_createVNode("strong", null, "Tax at standard rate:", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("strong", null, "Long-term care at standard rate:", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Income after deductions:")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Less allowances:")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Child allowances:")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Mortgage interest:")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Second earners allowance:")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Income taxed at marginal rate:")
const _hoisted_16 = /*#__PURE__*/_createVNode("strong", null, "Tax at marginal rate:", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("strong", null, "Long-term care at marginal rate:", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Marginal relief has reduced your tax and long-term care by:")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_grid = _resolveComponent("ion-grid")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_ion_grid, null, {
      default: _withId(() => [
        _createVNode(_component_ion_row, null, {
          default: _withId(() => [
            _createVNode(_component_ion_col, { class: "table-title" }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.title), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, null, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode(" £" + _toDisplayString(_ctx.numberWithCommas(_ctx.salary_income.total.toFixed(2))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, { class: "first-section" }, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col)
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, null, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode(" £" + _toDisplayString(_ctx.numberWithCommas(_ctx.work_pension_deductions.bik.toFixed(2))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, null, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode(" £" + _toDisplayString(_ctx.numberWithCommas(_ctx.work_pension_deductions.work.toFixed(2))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, null, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode(" £" + _toDisplayString(_ctx.numberWithCommas(_ctx.work_pension_deductions.pension.toFixed(2))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, { class: "first-section" }, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode(" £" + _toDisplayString(_ctx.numberWithCommas(_ctx.standard_taxable_income.total.toFixed(2))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.standard_tax.details[0])
          ? (_openBlock(), _createBlock(_component_ion_row, { key: 0 }, {
              default: _withId(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withId(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, null, {
                  default: _withId(() => [
                    _createVNode("strong", null, "£" + _toDisplayString(_ctx.numberWithCommas(_ctx.standard_tax.details[0].value.toFixed(2))), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.standard_tax.details[1])
          ? (_openBlock(), _createBlock(_component_ion_row, { key: 1 }, {
              default: _withId(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withId(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, null, {
                  default: _withId(() => [
                    _createVNode("strong", null, "£" + _toDisplayString(_ctx.numberWithCommas(_ctx.standard_tax.details[1].value.toFixed(2))), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ion_row, { class: "first-section" }, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode("£" + _toDisplayString(_ctx.numberWithCommas(_ctx.standard_taxable_income.total.toFixed(2))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, null, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_11
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col)
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, null, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode(" £" + _toDisplayString(_ctx.numberWithCommas(_ctx.other_allowances.child_allowances.toFixed(2))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, null, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_13
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode(" £" + _toDisplayString(_ctx.numberWithCommas(_ctx.other_allowances.mortgage_interest.toFixed(2))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_ion_row, null, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.total_tax_threshold.details[0].name) + ":", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode(" £" + _toDisplayString(_ctx.numberWithCommas(_ctx.total_tax_threshold.total.toFixed(2))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.married === true && !_ctx.independent)
          ? (_openBlock(), _createBlock(_component_ion_row, { key: 2 }, {
              default: _withId(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withId(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, null, {
                  default: _withId(() => [
                    _createTextVNode(" £" + _toDisplayString(_ctx.numberWithCommas(_ctx.second_earners.total.toFixed(2))), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ion_row, { class: "first-section" }, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_15
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode(" £" + _toDisplayString(_ctx.numberWithCommas(_ctx.marginal_taxable_income.total.toFixed(2))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.marginal_tax.details[0])
          ? (_openBlock(), _createBlock(_component_ion_row, { key: 3 }, {
              default: _withId(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withId(() => [
                    _hoisted_16
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, null, {
                  default: _withId(() => [
                    _createVNode("strong", null, "£" + _toDisplayString(_ctx.numberWithCommas(_ctx.marginal_tax.details[0].value.toFixed(2))), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.marginal_tax.details[1])
          ? (_openBlock(), _createBlock(_component_ion_row, { key: 4 }, {
              default: _withId(() => [
                _createVNode(_component_ion_col, null, {
                  default: _withId(() => [
                    _hoisted_17
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_col, null, {
                  default: _withId(() => [
                    _createVNode("strong", null, "£" + _toDisplayString(_ctx.numberWithCommas(_ctx.marginal_tax.details[1].value.toFixed(2))), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_ion_row, null, {
          default: _withId(() => [
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _hoisted_18
              ]),
              _: 1
            }),
            _createVNode(_component_ion_col, null, {
              default: _withId(() => [
                _createTextVNode(" £" + _toDisplayString(_ctx.numberWithCommas(_ctx.marginal_relief.toFixed(2))), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
})